import { CSSProperties, FC, ReactNode } from 'react';
import styled from 'styled-components';
import { u } from '../common/Units';

interface BlockContainerProps {
  children: ReactNode,
  className?: string,
  style?: CSSProperties,
}

const Block = styled.div`
  clear: both;
  display: flex;
  flex-direction: column;
  padding: 0 ${u(36)};
  max-width: ${p => p.theme.blockWidth};
  margin: 0 auto ${p => p.theme.blockMargin};

  &.slide {
    width: 100%;
    padding: 0;
    max-width: 100%;
  }
`;

/**
 * Render an article block container
 * @returns {JSX.Element} Component template
 */
const BlockContainer: FC<BlockContainerProps> = ({children, className, style}) => {

  return (
    <Block className={className} style={style}>
      {children}
    </Block>
  );
}

export default BlockContainer;
